export interface TocItem {
  level: number;
  text: string;
  line: number;
}

export type TocClickCallback = (line: number) => void;

export class TableOfContents {
  private container: HTMLElement;
  private isVisible: boolean = false;
  private items: TocItem[] = [];
  private onClick: TocClickCallback | null = null;

  constructor(containerId: string) {
    const container = document.getElementById(containerId);
    if (!container) {
      throw new Error(`Container ${containerId} not found`);
    }
    this.container = container;
  }

  update(content: string): void {
    this.items = this.parseHeadings(content);
    this.render();
  }

  private parseHeadings(content: string): TocItem[] {
    const lines = content.split('\n');
    const items: TocItem[] = [];

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const match = line.match(/^(#{1,6})\s+(.+)$/);
      if (match) {
        items.push({
          level: match[1].length,
          text: match[2].trim(),
          line: i + 1
        });
      }
    }

    return items;
  }

  private render(): void {
    if (!this.isVisible) return;

    if (this.items.length === 0) {
      this.container.innerHTML = '<div class="toc-empty">No hay encabezados</div>';
      return;
    }

    const ul = document.createElement('ul');
    ul.className = 'toc-list';

    for (const item of this.items) {
      const li = document.createElement('li');
      li.className = `toc-item toc-level-${item.level}`;
      li.textContent = item.text;
      li.title = `Ir a línea ${item.line}`;
      li.addEventListener('click', () => {
        if (this.onClick) {
          this.onClick(item.line);
        }
      });
      ul.appendChild(li);
    }

    this.container.innerHTML = '';
    this.container.appendChild(ul);
  }

  show(): void {
    this.isVisible = true;
    this.container.classList.remove('hidden');
    this.render();
  }

  hide(): void {
    this.isVisible = false;
    this.container.classList.add('hidden');
  }

  toggle(): boolean {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
    return this.isVisible;
  }

  isShowing(): boolean {
    return this.isVisible;
  }

  onItemClick(callback: TocClickCallback): void {
    this.onClick = callback;
  }
}
